import PropTypes from 'prop-types'
import React from 'react'

export const RemoveAddressBtn = ({onClick}) =>
  <a className='obrisi-model-btn removeBtn' onClick={onClick}>
    <span className='obrisi-model'>[-]</span> Obriši ovu adresu
  </a>

RemoveAddressBtn.propTypes = {
  onClick: PropTypes.func.isRequired
}
